import gql from 'graphql-tag'

export const GET_ORDER_PRODUCTS = gql`
  query getOrderProducts($orderSerno: String!) {
    getOrderProducts(orderSerno: $orderSerno) {
      id
      description
      amount
    }
  }
`

export const GET_SHOPPING_CART_PRODUCTS = gql`
  query getShoppingCartProducts($cartId: String!) {
    getShoppingCartProducts(cartId: $cartId) {
      id
      description
      amount
    }
  }
`
